import React from 'react'

import { Checkbox } from '../../Checkbox'
import { useDropdownContext } from '../DropdownContext'

const CheckboxOption = ({ ...rest }) => {
  const { onBlur } = useDropdownContext()

  return (
    <Checkbox
      role="menuitemcheckbox"
      className="checkbox-option"
      onBlur={onBlur}
      {...rest}
    />
  )
}

export default CheckboxOption
